import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import MytaskRow from './MytasRow';
import AddTaskComponent from '../Home/Components/AddTaskComponent';
import api from '../api/api';

const MyTasks = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("همه کارها");
  const [data, setData] = useState({
    "انجام نشده": [],
    "در حال انجام": [],
    "انجام شده": []
  });
  const [loading, setLoading] = useState(true);

  const columnStyles = {
    "انجام نشده": { border: "border-slate-400", text: "text-slate-800", badge: "bg-slate-200 text-slate-700" },
    "در حال انجام": { border: "border-indigo-500", text: "text-indigo-800", badge: "bg-indigo-100 text-indigo-700" },
    "انجام شده": { border: "border-green-500", text: "text-green-800", badge: "bg-green-100 text-green-700" }
  };

  const fetchTasks = async () => {
    try {
      const res = await api.get('/tasks/?role=assigned');
      const tasks = res.data;
      const grouped = {
        "انجام نشده": tasks.filter(t => t.status === 'انجام نشده'),
        "در حال انجام": tasks.filter(t => t.status === 'در حال انجام'),
        "انجام شده": tasks.filter(t => t.status === 'انجام شده')
      };
      setData(grouped);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(fetchTasks, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const handleAddTask = async (newTask) => {
    try {
      await api.post('/tasks/', { ...newTask, status: 'انجام نشده' });
      fetchTasks();
    } catch (error) {
      console.error('Error adding task:', error);
    }
  };

  const onDragEnd = async (result) => {
    const { source, destination } = result;
    if (!destination) return;
    const newData = { ...data };
    const [movedItem] = newData[source.droppableId].splice(source.index, 1);
    newData[destination.droppableId].splice(destination.index, 0, movedItem);
    setData(newData);
    try {
      await api.patch(`/tasks/${movedItem.id}/`, { status: destination.droppableId });
    } catch (error) {
      console.error('Error updating task status:', error);
      fetchTasks();
    }
  };

  const tabs = ["همه کارها", "انجام نشده", "در حال انجام", "انجام شده"];

  if (loading) return <div className="p-8 text-center">در حال بارگذاری...</div>;

  return (
    <div className="p-6 bg-slate-50 min-h-screen" dir="rtl">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-xl font-bold text-slate-800">مدیریت کارها</h1>
        <button onClick={() => setIsModalOpen(true)} className="bg-indigo-600 text-white px-6 py-2 rounded-xl text-sm font-bold shadow-lg hover:bg-indigo-700 transition-all">+ افزودن کار</button>
      </div>


      <div className="flex gap-8 mb-8 border-b border-slate-200">
        {tabs.map((tab) => (
          <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-sm font-bold ${activeTab === tab ? "text-indigo-600 border-b-2 border-indigo-600" : "text-slate-500 hover:text-slate-700"}`}>{tab}</button>
        ))}
      </div>

      <DragDropContext onDragEnd={onDragEnd}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {Object.keys(data).filter(col => activeTab === "همه کارها" || col === activeTab).map((columnName) => (
            <Droppable key={columnName} droppableId={columnName}>
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef} className="flex flex-col min-h-[500px]">
                  <div className={`flex justify-between items-center mb-4 pb-2 border-b-2 ${columnStyles[columnName].border}`}>
                    <h2 className={`font-bold text-lg ${columnStyles[columnName].text}`}>{columnName}</h2>
                    <span className={`w-10 h-10 flex items-center justify-center rounded-full text-lg font-black shadow-sm ${columnStyles[columnName].badge}`}>{data[columnName].length}</span>
                  </div>
                  {data[columnName].map((item, index) => (
                    <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className="mb-3">
                          <MytaskRow {...item} />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          ))}
        </div>
      </DragDropContext>

      {isModalOpen && <AddTaskComponent onClose={() => { setIsModalOpen(false); fetchTasks(); }} forcedAssignee='خودم' />}
    </div>
  );
};

export default MyTasks;